import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import StockNotifyButton from 'components/product/StockNotifyButton/StockNotifyButton'

import messages from './messages'
import s from './OutOfStockNotifyModal.scss'


class OutOfStockNotifyModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    data: PropTypes.shape({
      productId: PropTypes.number.isRequired,
    }),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.OutOfStockNotify,
    title: messages.title,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title, data: { isSubscribedToStockNotification, productId } } = this.props

    return (
      <Modal
        name={name}
        title={title}
      >
        <FormattedMessage {...messages.text} />
        <ModalFooter>
          <StockNotifyButton
            className={s.notifyButton}
            productId={productId}
            isSubscribedToStockNotification={isSubscribedToStockNotification}
            onSubscribeToStockNotification={this.close}
          />
        </ModalFooter>
      </Modal>
    )
  }
}


export default OutOfStockNotifyModal
